import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './keyword.reducer';

export const KeywordDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const keywordEntity = useAppSelector(state => state.keyword.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="keywordDetailsHeading">
          <Translate contentKey="activitiesApp.keyword.detail.title">Keyword</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{keywordEntity.id}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="activitiesApp.keyword.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {keywordEntity.createdDate ? <TextFormat value={keywordEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="keyword">
              <Translate contentKey="activitiesApp.keyword.keyword">Keyword</Translate>
            </span>
          </dt>
          <dd>{keywordEntity.keyword}</dd>
          <dt>
            <span id="valid">
              <Translate contentKey="activitiesApp.keyword.valid">Valid</Translate>
            </span>
          </dt>
          <dd>{keywordEntity.valid ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/keyword" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/keyword/${keywordEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default KeywordDetail;
